// 400是键盘高度测试极值，在取不到可视区域以及ios没有给到键盘高度时使用
let cacheKeyboardHeight = 400;
// ios 工具栏高度
let cacheToolbarHeight = 0;
// 编辑器内容以外的元素高度
let cacheExtraEditorHeight = 60;
// 编辑器正文行高
const lineHeight = 34;

function isAndroid() {
  const ua = window.navigator.userAgent;
  return ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1;
}

function getOffsetTop(dom) {
  let top = 0;
  function loop(pDom) {
    if (!pDom) {
      return top;
    }
    top = top + pDom.offsetTop;
    return loop(pDom.offsetParent);
  }

  return loop(dom);
}
export default function (quill) {
  blurWhenUserTouchScroll(quill);
  setTimeout(() => {
    cacheExtraEditorHeight = isPc() ? '0' : document.documentElement.offsetHeight - quill.root.clientHeight;
  });
  quill.on('text-change', function (delta) {
    // http://jira.haodf.net/browse/FWBJKJTHZL-739
    // const delta = quill.getContents();
    // 先只处理插入空格？
    const { ops } = delta;
    if (
      ops.some(item => typeof item.insert === 'string' || (item.attributes && item.attributes.hasOwnProperty('link'))
        // && item.insert === '\n'
      )
    ) {
      setTimeout(() => {
        _resetScroll(quill);
      }, 0);
    }
  });
  if (isAndroid()) {
    window.addEventListener('resize', () => {
      _resetScroll(quill);
    });
  }
  // ios键盘失焦
  window.blurKeyboard = function () {
    document.body.style.paddingBottom = 0;
  };
  // ios调用的聚焦时遮挡问题，（因为其有一个吸附在键盘上的工具栏，所以通过其传值，矫正滚动位置，并且缓存键盘高度
  window.focusScrollReset = function (value) {
    const { toolbarHeight = 0, keyboardHeight = 400 } = value;
    cacheKeyboardHeight = keyboardHeight;
    cacheToolbarHeight = toolbarHeight;
    document.body.style.paddingBottom = cacheToolbarHeight + cacheKeyboardHeight + 'px';
    const tagName = document.activeElement.tagName;
    // 聚焦在自定义组件的输入框时，ios不显示工具栏，不需要进行校正
    if (tagName !== 'DIV') {
      return;
    }
    setTimeout(() => {
      const selection = quill.selection;
      /* eslint-disable */
      const [range, nativeRange] = selection.getRange();
      /* eslint-enable */
      if (!nativeRange) {
        return;
      }
      let anchorNode = nativeRange.start.node;
      if (!anchorNode) {
        anchorNode = nativeRange.end.node;
      }
      const parent = anchorNode.parentNode;
      const ih = parent.offsetHeight;
      // const it = parent.offsetTop;
      const it = getOffsetTop(parent);
      const ch = window.visualViewport
        ? window.visualViewport.height - cacheExtraEditorHeight - cacheToolbarHeight
        : document.documentElement.clientHeight - (cacheKeyboardHeight + (cacheToolbarHeight * 2));
      if (it >= 0 && it < (ch - lineHeight)) {
        return;
      }
      const y = it - ch + ih + lineHeight + 30;
      // const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      // window.scrollTo(0, scrollTop + Number(cacheToolbarHeight));
      window.scrollTo(0, y);
    }, 100);
  };
}
export function isPc() {
  const userAgentInfo = navigator.userAgent;
  const Agents = ['Android', 'iPhone',
    'SymbianOS', 'Windows Phone',
    'iPad', 'iPod'];
  let flag = true;
  for (let v = 0, j = Agents.length; v < j; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}
// ios输入空格及文字处理滚动处理
export async function _resetScroll(quill) {
  const selection = quill.selection;
  /* eslint-disable */
  // 获取选区信息
  const [range, nativeRange] = selection.getRange();

  /* eslint-enable */
  if (!nativeRange) {
    return;
  }
  // 获取选区所在node节点信息
  let anchorNode = nativeRange.start.node;
  if (!anchorNode) {
    anchorNode = nativeRange.end.node;
  }
  // 取其父容器节点
  const focusNode = anchorNode.parentNode;
  // 容器高度
  const ih = focusNode.offsetHeight;
  // 容器距离文档顶部距离
  // const it = focusNode.offsetTop;
  const it = getOffsetTop(focusNode);
  // ch为可视区域
  // ios13以上及安卓系统才可以取到visualViewPort属性，该值减去大标题高度（60）即为编辑内容区可视高度（备注：该值在弹起键盘时会发生变化
  // 取不到visualViewPort时，利用文档总高度减去键盘高度再减去工具栏高度（这里为什么乘2，是因为ios在布局时，在下方增加了工具栏高度的内边距
  let ch = '';

  if (isAndroid()) {
    ch = window.visualViewport
      ? window.visualViewport.height - cacheExtraEditorHeight - cacheToolbarHeight
      : window.screen.availHeight - (cacheKeyboardHeight + (cacheToolbarHeight * 2));
  } else {
    ch = window.visualViewport
      ? window.visualViewport.height - cacheExtraEditorHeight - cacheToolbarHeight
      : document.documentElement.clientHeight - (cacheKeyboardHeight + (cacheToolbarHeight * 2));
  }
  // 获取选区在节点内的具体位置信息
  const selectRange = document.createRange();
  selectRange.selectNode(anchorNode);
  selectRange.setStart(nativeRange.start.node, nativeRange.start.offset);
  selectRange.setEnd(nativeRange.end.node, nativeRange.end.offset);
  const { top } = selectRange.getBoundingClientRect();
  // 光标在可视范围内， 就不在滚动了
  if (top > 0 && top < ch) {
    return;
  }
  // 滚动距离 = 节点距离文档顶部距离 - 可视区域高度 + 节点自身高度 + 正文行高 + 预留超链接编辑tooltip空间
  const y = it - ch + ih + lineHeight + 30;
  window.scrollTo(0, y);
}
// 用户滚动失焦方法
function blurWhenUserTouchScroll(quill) {
  let y1 = 0; let y2 = 0;
  window.addEventListener('touchstart', function (e) {
    y1 = e.touches[0].clientY;
  });
  window.addEventListener('touchend', function (e) {
    y2 = e.changedTouches[0].clientY;
    // 非选择内容状态下才执行以下逻辑 http://jira.haodf.net/browse/FWBJKJTHZL-646
    const range = quill.getSelection();
    if (range && range.length === 0 && Math.abs(y1 - y2) > 20) {
      quill.blur();
    }
    y1 = 0;
    y2 = 0;
  });
}
